import { css } from 'styled-components';

import { theme } from './colors';

export const InputStyle = css`
  .MuiFormLabel-root {
    color: #bfc4ca;
    &.Mui-focused {
      color: #0094d9;
    }
  }
  .MuiFormControl-marginNormal {
    margin-top: 0px;
  }
  .date-picker-input {
    .MuiInputBase-root {
      border: 1px solid ${theme.divider_and_border.input_border};
      padding-left: 16px;
      border-radius: 4px;
      transition: 0.3s ease-in-out all;
      &:hover {
        border: 1px solid ${theme.divider_and_border.input_border_hover};
      }
      &.Mui-focused {
        border: 1px solid ${theme.divider_and_border.input_border_hover};
      }
    }
    .MuiInput-underline:before,
    .MuiInput-underline:after {
      display: none;
    }
  }

  .MuiFilledInput-root {
    border: 1px solid ${theme.divider_and_border.input_border};
    background: white;
    &:hover {
      border: 1px solid ${theme.divider_and_border.input_border_hover};
    }
  }

  input:-internal-autofill-selected {
    appearance: menulist-button;
    background-color: rgb(255, 255, 255) !important;
    background-image: none !important;
    color: -internal-light-dark(black, white) !important;
  }

  .MuiListItemIcon-root {
    width: 24px;
    min-width: 24px;
    margin-right: 12px;
    height: 24px;
  }

  .MuiFilledInput-underline:after,
  .MuiFilledInput-underline:before {
    display: none;
  }

  .MuiFilledInput-root {
    border: 1px solid #bfc4ca;
  }

  .MuiSelect-select:focus {
    background-color: rgba(0, 0, 0, 0);
  }

  .MuiInputBase-root {
    border-radius: 4px;
    overflow: hidden;
    height: 56px;
    &.MuiFilledInput-multiline {
      height: unset;
    }
    &:hover {
      background-color: white;
    }
  }
  .MuiFilledInput-root.Mui-focused {
    background-color: rgba(0, 0, 0, 0);
  }

  .MuiFilledInput-root:focus,
  .MuiFilledInput-root:hover {
    background-color: white;
  }

  .MuiFilledInput-root:hover {
    border: 1px solid #0094d9;
  }

  .MuiFilledInput-root:focus,
  .MuiFilledInput-root:hover {
    background-color: rgba(0, 0, 0, 0);
  }
  .MuiListItemIcon-root {
    vertical-align: middle;
  }

  .MuiTypography-root {
    line-height: 26px;
  }
  .MuiSelect-selectMenu {
    min-height: unset;
  }

  .MuiSelect-iconFilled {
    top: 24px;
  }

  // Disabled
  .MuiFormLabel-root.Mui-disabled {
    color: ${theme.greys.grey020};
  }
  .MuiFilledInput-root.Mui-disabled {
    background-color: ${theme.greys.grey000};
    pointer-events: none;
  }

  @media (hover: none) {
    .MuiFilledInput-root:hover {
      background-color: rgba(0, 0, 0, 0);
    }
  }
`;

export const RadioStyle = css`
  .MuiRadio-colorSecondary.Mui-checked {
    color: #0094d9;
  }
  .MuiFormControlLabel-root {
    margin-left: 0px;
    margin-left: 0px;
    .MuiButtonBase-root {
      padding: 0;
      width: auto;
      height: auto;
    }
    .MuiTouchRipple-root {
      display: none;
    }
  }
`;

export const IconButtonStyle = css`
  .MuiIconButton-root {
    border-radius: 6px;
  }
  .MuiButtonBase-root {
    width: 100%;
    height: 100%;
  }
  .MuiIconButton-label {
    width: auto;
  }
`;
